import { useContext } from 'react';
import type { StaticProductView } from 'state/product-description/types';

import { ProductViewContext } from '../contexts/ProductViewContext';

export function useProductView(): StaticProductView {
  return useContext(ProductViewContext);
}
